// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Checkbox from '../Checkbox';

const providers = [
    {
        provider: "sfax",
        name: "Sfax",
        icon: "sfax.png"
    },
    // {
    //     provider: "efax",
    //     name: "eFax",
    //     icon: "efax.png"
    // }
];

export default class InboundFax extends React.Component {

    render = () => {

        const fax = this.props.team && this.props.team.fax ? this.props.team.fax : {
            enableInbound: false,
            service: {
                provider: "",
                apiKey: ""
            }
        };

        return (<div className="settings-content">
            
            <p>
                Stax·ai can connect to your electronic fax account and sort incoming faxes into your stacks. Make all your faxes searchable and extract useful information from your them by connecting your fax account to Stax through our secure fax API.
            </p><br />

            <Checkbox
                label="Intercept inbound faxes"
                checked={fax.enableInbound}
                onToggle={() => this.props.updateTeam({
                    ...this.props.team,
                    fax: {
                        ...this.props.team.fax,
                        enableInbound: !fax.enableInbound
                    }
                })}
            />

            <h2>Electronic Fax Service Provider</h2>

            <div className="settings-fax-provider-list">
                {providers.map((p,idx) => <div
                    className={"settings-fax-provider" + (fax.service.provider === p.provider ? " settings-fax-provider-active" : "")}
                    key={idx}
                    title={p.name}
                    style={{
                        backgroundImage: "url('https://static.stax.ai/images/fax/" + p.icon + "')"
                    }}
                    onClick={() => this.props.updateTeam({
                        ...this.props.team,
                        fax: {
                            ...fax,
                            service: {
                                ...fax.service,
                                provider: p.provider
                            }
                        }
                    })}
                >
                </div>)}
            </div>

            <div style={{ clear: 'both' }} />
{/* 
            <p>
                If you use a different electronic fax service provider, please <a href="mailto:mckenzie@stax.ai">let us know</a>!<br />
                We'll work with you to add support for your provider.
            </p> */}

            <h2>API Integration Settings</h2>

            <div className="settings" style={{ marginLeft: -20 }}>

                <label>Secret API Key</label>
                <input
                    id="key"
                    name="key"
                    type="text"
                    placeholder="Enter secret API key..."
                    value={fax.service.apiKey}
                    onChange={e => this.props.updateTeam({
                        ...this.props.team,
                        fax: {
                            ...fax,
                            service: {
                                ...fax.service,
                                apiKey: e.target.value
                            }
                        }
                    }, false)}
                />

            </div>

        </div>);
    }

};